import { Link } from "react-router-dom";

import "./footer.css";

function Footer() {
    return <div className="footer">
        <p>
            Theresienstraße 148<br/>
            80336 München<br/>
            <br/>
            089/43630076<br/>
            info@tanztherapie-münchen.de
        </p>
        <Link to="/impressum" >Impressum</Link>
        <Link to="/datenschutz" >Datenschutzerklärung</Link>
    </div>
}

export default Footer;